const widgetSizeExpandGrow = {
    svg: '<svg style="width:1.06rem; height:1.00rem;" viewBox="0 0 17 16"><path d="M13.75 12.177v1.5H2.25v-1.5zM8 2l3.54 3.677H8.842v4.1h4.908v1.5H2.25v-1.5H7.2v-4.1H4.46z"/></svg>',
};

export { widgetSizeExpandGrow as default };
